// Programa de Bienvenida (el ingreso de una persona nueva; docs/planes/CURSOS_PLAN.md §0.1 #44 y #46) — lo que la pantalla
// le pide al servidor (functions/bienvenida/).
//   - bienvenidaAccion: RRHH desde el Expediente → estado (la lista del primer día) · contrasena (la carta) · marcar.
//   - crearContrasenaPrimerIngreso: la persona nueva, en el Login, justo después de entrar con la contraseña de su carta.
// Todo lo que escribe pasa por esas funciones: la ficha (`usuarios`) no deja que el navegador toque la marca.
import { auth } from './firebase';

const FUNCTIONS_URL = 'https://us-central1-app-newparalellum.cloudfunctions.net';

async function llamar(nombre, cuerpo, tope = 60000) {
  const control = new AbortController();
  const reloj = setTimeout(() => control.abort(), tope);
  try {
    const token = auth.currentUser ? await auth.currentUser.getIdToken() : '';
    const r = await fetch(`${FUNCTIONS_URL}/${nombre}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify(cuerpo || {}),
      signal: control.signal,
    });
    const res = await r.json().catch(() => ({ success: false, error: 'El servidor no respondió. Probá de nuevo en un momento.' }));
    if (!res.success) {
      const e = new Error(res.error || 'No se pudo completar. Probá de nuevo.');
      // Las señales que la pantalla necesita para decidir qué hacer (sesión vieja, ya tenía la suya).
      if (res.sesionVieja) e.sesionVieja = true;
      if (res.yaTieneLaSuya) e.yaTieneLaSuya = true;
      throw e;
    }
    return res;
  } catch (e) {
    if (e.name === 'AbortError') throw new Error('Tardó demasiado. Probá de nuevo.');
    throw e;
  } finally {
    clearTimeout(reloj);
  }
}

/** RRHH: 'estado' { uid } · 'contrasena' { uid, nuevaPassword } · 'marcar' { uid, paso, hecho }. */
export const bienvenidaAccion = (accion, datos = {}) => llamar('bienvenidaAccion', { ...datos, accion });

/** La persona nueva crea su propia contraseña (la de la carta deja de servir). */
export const crearContrasenaPrimerIngreso = (nuevaPassword) => llamar('bienvenidaCrearContrasena', { nuevaPassword });
